import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import {
  ChevronDownIcon,
  DocumentIcon,
  PrinterIcon,
} from "@heroicons/react/24/outline";
import { FC, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { BookContext } from "../contexts/BookContext";
import { PDFBookIcon } from "../icons";
import { PrintModal } from "./Modals/PrintModal";

export const PrintBookCard: FC = () => {
  const { t } = useTranslation();
  const { book, subscription } = useContext(BookContext);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);

  return (
    <div className="bg-white w-full lg:w-1/2 flex flex-col justify-between shadow-md rounded py-4 sm:py-6 px-4 sm:px-6">
      <div className="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center">
        <div className="flex flex-col w-full sm:w-4/6 mb-4 sm:mb-0">
          <p className="text-slate-700 text-2xl sm:text-3xl lg:text-4xl font-bold">
            {t("dashboard.book_generated")}
          </p>
          <p className="text-slate-50 text-sm sm:text-md mt-2 sm:mt-4">
            {t("dashboard.book_generated_description")}
          </p>
        </div>
        <div className="flex flex-col w-full sm:w-1/6 items-center justify-center rounded border border-gray-300 py-4">
          <PDFBookIcon className="h-16 w-16 sm:h-20 sm:w-20 lg:h-24 lg:w-24" />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row w-full justify-between items-center mt-4 sm:mt-6 space-y-4 sm:space-y-0 sm:space-x-4">
        {book && (
          <>
            {subscription && subscription.product === "pdf" ? (
              <Link
                to={book.numeric_pdf_url}
                target="blank"
                className="flex w-full sm:w-80 items-center justify-center bg-sand-500 hover:bg-sand-800 text-white text-sm sm:text-lg rounded px-4 sm:px-6 py-2"
                download
              >
                <DocumentIcon className="h-5 w-5 sm:h-6 sm:w-6 mr-2" />
                {t("dashboard.downloadPDFBook")}
              </Link>
            ) : (
              <>
                <Menu
                  as="div"
                  className="relative inline-block text-left w-full sm:w-80"
                >
                  <MenuButton className="flex justify-between w-full bg-sand-300 hover:bg-sand-800 text-white text-sm sm:text-lg rounded px-4 sm:px-6 py-2 items-center">
                    <div className="flex items-center">
                      <DocumentIcon className="h-5 w-5 sm:h-6 sm:w-6 mr-2" />
                      {t("dashboard.downloadPDFBook")}
                    </div>
                    <ChevronDownIcon className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
                  </MenuButton>

                  <MenuItems className="absolute left-0 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                    <div className="py-1">
                      <MenuItem>
                        {({ active }) => (
                          <Link
                            to={book.cover_pdf_url}
                            target="_blank"
                            download
                            className={`block px-4 py-2 text-sm text-gray-700 ${
                              active ? "bg-gray-100" : ""
                            }`}
                          >
                            {t("dashboard.downloadCover")}
                          </Link>
                        )}
                      </MenuItem>
                      <MenuItem>
                        {({ active }) => (
                          <Link
                            to={book.content_pdf_url}
                            target="_blank"
                            download
                            className={`block px-4 py-2 text-sm text-gray-700 ${
                              active ? "bg-gray-100" : ""
                            }`}
                          >
                            {t("dashboard.downloadContent")}
                          </Link>
                        )}
                      </MenuItem>
                    </div>
                  </MenuItems>
                </Menu>
                <button
                  onClick={() => setIsPrintModalOpen(true)}
                  className="flex w-full sm:w-80 items-center justify-center bg-white border border-rust-50 hover:bg-rust-50 hover:text-white text-rust-50 text-sm sm:text-lg rounded px-4 sm:px-6 py-2"
                >
                  <PrinterIcon className="h-5 w-5 sm:h-6 sm:w-6 mr-2" />
                  {t("dashboard.printBook")}
                </button>
                {isPrintModalOpen && (
                  <PrintModal
                    open={isPrintModalOpen}
                    setOpen={setIsPrintModalOpen}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
